import { Button, Icon } from "@qw/ui";

import { useChat } from "../providers/chat-provider";

export const ChatScrollToBottom = () => {
  const { resumeAutoScroll } = useChat();

  return (
    <div className="z-100 absolute bottom-full right-2 mb-2 2xl:right-3 2xl:mb-3">
      <Button variant="outline" display="icon" size="sm" onClick={resumeAutoScroll}>
        <Icon icon="arrow_downward" />
      </Button>
    </div>
  );
};
